import messages from "../../../locale/jsonMessages";

const validate = values => {

    const errors = {}
    if (values.paymentType == '1' && !values.paymentCurrency) {
        errors.paymentCurrency = messages.required;
    }

    return errors;
}

export default validate;